module.exports = __webpack_public_path__ + "media/images/icon-aa9c6b760869c4db517ab99e2a3eb1ff.png";